import { Ref, ref } from "vue";
import { DialogService } from "@/service/DialogService";
import { BukaDetail } from "@/types/MstBuka";
import { AxiosError } from "axios";
import { FormUtil } from "@/utils/FormUtil";
import { useForm } from "@/composable/form/form";
import { SyuugyouBasyoService } from "@/service/SyuugyouBasyoService";
import { SyuugyouBasyo, UpsertSyuugyouBasyoRes } from "@/types/KoyouKeiyaku";

export function useSyuugyouBasyoEdit() {
  const srv = new SyuugyouBasyoService();
  const { removeAllError } = useForm()

  const syuugyouBasyoEditObj: Ref<SyuugyouBasyo | null> = ref(null)

  const initSyuugyouBasyoEditObj = (bukaDetail: BukaDetail) => {
    syuugyouBasyoEditObj.value = {
      mst_buka_id: bukaDetail.mst_buka_id,
      mst_syuugyou_basyo_id: null,
      syuugyou_basyo_name: bukaDetail.buka_name ?? '',
      syuugyou_basyo_kana: bukaDetail.buka_kana ?? '',
      syuugyou_basyo_address: '',
      syuugyou_basyo_tel: '',
    }
  }

  const deleteSyuugyouBasyoEditObj = async () => {
    syuugyouBasyoEditObj.value = null
  }

  const upsertSyuugyouBasyo = async (syuugyouBasyo: Ref<SyuugyouBasyo | null>) => {
    let res: UpsertSyuugyouBasyoRes = {
      result: false,
      message: '',
      bukaId: null
    }

    if (!syuugyouBasyo.value) return res

    DialogService.nowloading('登録中...')

    try {
      removeAllError(syuugyouBasyo.value)
      res = await srv.upsertSyuugyouBasyo(syuugyouBasyo.value)

      if (res.result) {
        await DialogService.info({
          html: res.message
        }, true)

      } else if (res.message) {
        await DialogService.error({
          html: res.message ?? '不明なエラーが発生しました'
        }, true)
      }
      return res
    } catch (e) {
      const err = e as AxiosError<any>
      FormUtil.setLaravelError(syuugyouBasyo.value, err)
      return res
    }
  }

  const deleteSyuugyouBasyo = async (syuugyouBasyoId: number) => {
    DialogService.nowloading('削除中...')

    try {
      const res = await srv.deleteSyuugyouBasyo(syuugyouBasyoId)
      if (res.result) {
        await DialogService.info({
          html: '削除に成功しました。<br>再読込します。'
        }, true)
      } else if (res.message) {
        await DialogService.error({
          html: res.message ?? '不明なエラーが発生しました'
        }, true)
      }
      return true
    } catch (e) {
      return false
    }
  }

  return {
    syuugyouBasyoEditObj,
    initSyuugyouBasyoEditObj,
    deleteSyuugyouBasyoEditObj,
    upsertSyuugyouBasyo,
    deleteSyuugyouBasyo
  }
}
